export default "__VITE_ASSET__ucuyQuhP__"